import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

const { spacing } = THEME;

export const styleSheet = StyleSheet.create({
	ctaButton: {
		background: '#6974FB1b',
		border: 'none',
		boxShadow: 'none',
		color: '#6974FB',
		fontWeight: 400,
		marginTop: spacing.lg,
	},
	integrationTitle: {
		color: '#6974FB',
	},
	logo: {
		borderRadius: spacing.md,
		height: spacing.xxl,
		marginRight: -10,
		width: spacing.xxl,
	},
});
